import { useTranslation } from "react-i18next";
import { useRemoveSavedForLaterItemMutation } from "../api/savedForLaterApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

/**
 * A custom hook to encapsulate the logic for removing an item from the 'Saved for Later' list.
 *
 * Feedback Strategy:
 * - Loading: Toast shown.
 * - Success: No toast.
 * - Error: Toast shown.
 */
export const useRemoveFromSavedForLater = () => {
  const { t } = useTranslation();
  const [removeSavedItem, result] = useRemoveSavedForLaterItemMutation();

  const { trigger: handleRemoveFromSavedForLater, isLoading: isRemoving } =
    useMutationWithFeedback<number[], number>({
      mutation: [removeSavedItem, result],
      loadingMessage: t("feedback.savedForLater.removing", "Removing item..."),
      successMessage: null, // Explicitly disabled success message
      errorMessages: {
        default: t(
          "feedback.savedForLater.removeError",
          "Failed to remove item."
        ),
      },
    });

  return {
    handleRemoveFromSavedForLater,
    isRemoving,
  };
};
